import Emittery from 'emittery';

const bus = new Emittery();

export default bus;
